import type { Doc } from 'yjs';
import type { SkippedContentTypeRefreshField } from '../../../form/ContentObjectForm/helpers/contentTypeRefreshSnapshot';

/** Removes fields that don't survive the schema change from the shared yjs values. */
export const dropIncompatibleYjsValues = (
  yjsDocument: Doc | undefined,
  incompatibleFields: SkippedContentTypeRefreshField[],
) => {
  const yjsValues = yjsDocument?.getMap('vals');
  yjsDocument?.transact(() => {
    incompatibleFields.forEach(({ key }) => yjsValues?.delete(key));
  });
};
